import React from 'react';
import { GraduationCap } from 'lucide-react';
import FormModalLayout from '../Common/FormModalLayout';
import Can from '../Common/Can';
import { P } from '../../constants/permissions';

const ProfessionalFormationModal = ({ formation, persons = [], onSubmit, onClose }) => {
  const [formData, setFormData] = React.useState({
    person_id: formation?.person_id || '',
    name: formation?.course || formation?.name || '',
    institution: formation?.institution || '',
    level: formation?.level || 'GRADUATION',
    status: formation?.is_active === false ? 'INACTIVE' : 'ACTIVE',
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(formData);
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  return (
    <FormModalLayout
      title={formation ? 'Editar formação profissional' : 'Nova formação profissional'}
      subtitle="Cursos e níveis vinculados a responsáveis técnicos."
      headerIcon={GraduationCap}
      onClose={onClose}
      size="md"
      historyEntityType="professional_formations"
      historyEntityId={formation?.id}
      footer={
        <>
          <button type="button" onClick={onClose} className="btn btn-outline">
            Cancelar
          </button>
          <Can permission={P.PROFESSIONAL_ACCESS}>
            <button type="submit" form="pro-formation-modal-form" className="btn btn-primary">
              {formation ? 'Atualizar' : 'Criar'}
            </button>
          </Can>
        </>
      }
    >
      <form id="pro-formation-modal-form" onSubmit={handleSubmit} className="form-stack">
        <div className="form-group">
          <label htmlFor="pf-person" className="form-label form-label-required">
            Pessoa
          </label>
          <select
            id="pf-person"
            name="person_id"
            value={formData.person_id}
            onChange={handleChange}
            className="form-select"
            required
          >
            <option value="">Selecione a pessoa</option>
            {persons.map((person) => (
              <option key={person.id} value={person.id}>
                {person.name || person.id}
              </option>
            ))}
          </select>
        </div>
        <div className="form-group">
          <label htmlFor="pf-name" className="form-label form-label-required">
            Nome do curso
          </label>
          <input
            id="pf-name"
            type="text"
            name="name"
            value={formData.name}
            onChange={handleChange}
            className="form-input"
            required
          />
        </div>
        <div className="form-group">
          <label htmlFor="pf-inst" className="form-label form-label-required">
            Instituição
          </label>
          <input
            id="pf-inst"
            type="text"
            name="institution"
            value={formData.institution}
            onChange={handleChange}
            className="form-input"
            required
          />
        </div>
        <div className="form-group">
          <label htmlFor="pf-level" className="form-label">
            Nível
          </label>
          <select
            id="pf-level"
            name="level"
            value={formData.level}
            onChange={handleChange}
            className="form-select"
          >
            <option value="GRADUATION">Graduação</option>
            <option value="SPECIALIZATION">Especialização</option>
            <option value="MASTER">Mestrado</option>
            <option value="DOCTORATE">Doutorado</option>
          </select>
        </div>
        <div className="form-group">
          <label htmlFor="pf-status" className="form-label">
            Status
          </label>
          <select
            id="pf-status"
            name="status"
            value={formData.status}
            onChange={handleChange}
            className="form-select"
          >
            <option value="ACTIVE">Ativo</option>
            <option value="INACTIVE">Inativo</option>
          </select>
        </div>
      </form>
    </FormModalLayout>
  );
};

export default ProfessionalFormationModal;
